import React, { useState } from 'react';
import { FaPhone, FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaClock } from 'react-icons/fa';

export default function ContactUs() {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {

      await new Promise(resolve => setTimeout(resolve, 1500));

      setSubmitMessage(
        'Thank you for contacting SourceCodey. Our team will get back to you shortly.'
      );

      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });

    } catch (error) {

      setSubmitMessage(
        'There was an error sending your message. Please try again.'
      );

    } finally {

      setIsSubmitting(false);
      setTimeout(() => setSubmitMessage(''), 5000);

    }
  };

  const contactEmail = "sourcecodey.com@gmail.com";
  const contactNumber = "+256708435802";
  const whatsappNumber = "+256708435802";
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/\D/g, '')}`;

  return (
    <div className="max-w-6xl mx-auto px-4 py-12 bg-black text-gray-100">

      <div className="text-center mb-12">

        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-[#4FC3F7] to-[#FF4DA6]">
          Contact SourceCodey
        </h1>

        <p className="text-lg text-gray-400 max-w-2xl mx-auto">
          Have questions about selling or buying digital products, code, apps, courses or design assets?  
          Reach out to the SourceCodey team and we will assist you quickly.
        </p>

      </div>


      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">


        {/* CONTACT INFO */}

        <div className="space-y-6">

          <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">

            <h2 className="text-2xl font-semibold mb-6 text-white">
              Contact Information
            </h2>

            <div className="space-y-6">


              {/* CALL */}

              <div className="flex items-start space-x-4">

                <div className="bg-[#4FC3F7] p-3 rounded-full">
                  <FaPhone className="text-xl text-black" />
                </div>

                <div>
                  <h3 className="font-semibold text-lg text-white">
                    Call Us
                  </h3>

                  <p className="text-gray-400">
                    +256 708 435 802
                  </p>

                  <a
                    href={`tel:${contactNumber}`}
                    className="mt-2 inline-block bg-[#4FC3F7] text-black px-4 py-2 rounded-md hover:bg-[#3bb2e6] transition-colors"
                  >
                    Call Now
                  </a>
                </div>

              </div>


              {/* WHATSAPP */}

              <div className="flex items-start space-x-4">

                <div className="bg-[#25D366] p-3 rounded-full">
                  <FaWhatsapp className="text-xl text-white" />
                </div>

                <div>
                  <h3 className="font-semibold text-lg text-white">
                    WhatsApp
                  </h3>

                  <p className="text-gray-400">
                    Chat with our support team
                  </p>

                  <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-2 inline-block bg-[#25D366] text-white px-4 py-2 rounded-md hover:bg-[#1da851] transition-colors"
                  >
                    Message on WhatsApp
                  </a>

                </div>

              </div>


              {/* EMAIL */}

              <div className="flex items-start space-x-4">

                <div className="bg-[#FF4DA6] p-3 rounded-full">
                  <FaEnvelope className="text-xl text-white" />
                </div>

                <div>

                  <h3 className="font-semibold text-lg text-white">
                    Email Us
                  </h3>

                  <p className="text-gray-400">
                    {contactEmail}
                  </p>

                  <a
                    href={`mailto:${contactEmail}`}
                    className="mt-2 inline-block bg-[#FF4DA6] text-white px-4 py-2 rounded-md hover:bg-[#e63b8f] transition-colors"
                  >
                    Send Email
                  </a>

                </div>

              </div>


              {/* LOCATION */}

              <div className="flex items-start space-x-4">

                <div className="bg-gradient-to-r from-[#4FC3F7] to-[#FF4DA6] p-3 rounded-full">
                  <FaMapMarkerAlt className="text-xl text-white" />
                </div>

                <div>
                  <h3 className="font-semibold text-lg text-white">
                    Our Location
                  </h3>

                  <p className="text-gray-400">
                    Kampala, Uganda
                  </p>
                </div>

              </div>

            </div>

          </div>



          {/* BUSINESS HOURS */}

          <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">

            <div className="flex items-center mb-4">
              <FaClock className="text-2xl mr-3 text-[#4FC3F7]" />
              <h2 className="text-2xl font-semibold text-white">
                Business Hours
              </h2>
            </div>

            <ul className="space-y-3">

              <li className="flex justify-between text-gray-300">
                <span className="font-medium">
                  Monday - Friday
                </span>
                <span>8:00 AM - 6:00 PM</span>
              </li>

              <li className="flex justify-between text-gray-300">
                <span className="font-medium">
                  Saturday
                </span>
                <span>9:00 AM - 3:00 PM</span>
              </li>

              <li className="flex justify-between text-gray-300">
                <span className="font-medium">
                  Sunday
                </span>
                <span>Closed</span>
              </li>

            </ul>

          </div>

        </div>



        {/* CONTACT FORM */}

        <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">

          <h2 className="text-2xl font-semibold mb-6 text-white">
            Send Us a Message
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">


            <div>

              <label className="block text-sm font-medium text-gray-300 mb-1">
                Your Name
              </label>

              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:ring-2 focus:ring-[#4FC3F7] focus:border-[#4FC3F7] outline-none transition text-white"
              />

            </div>


            <div>

              <label className="block text-sm font-medium text-gray-300 mb-1">
                Email Address
              </label>

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:ring-2 focus:ring-[#4FC3F7] focus:border-[#4FC3F7] outline-none transition text-white"
              />

            </div>


            <div>

              <label className="block text-sm font-medium text-gray-300 mb-1">
                Subject
              </label>

              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:ring-2 focus:ring-[#4FC3F7] focus:border-[#4FC3F7] outline-none transition text-white"
              />

            </div>


            <div>

              <label className="block text-sm font-medium text-gray-300 mb-1">
                Your Message
              </label>

              <textarea
                name="message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:ring-2 focus:ring-[#4FC3F7] focus:border-[#4FC3F7] outline-none transition text-white"
              />

            </div>


            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full bg-gradient-to-r from-[#4FC3F7] to-[#FF4DA6] text-white py-3 px-4 rounded-md hover:opacity-90 transition ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
            >

              {isSubmitting ? 'Sending...' : 'Send Message'}

            </button>


            {submitMessage && (

              <div className={`mt-4 p-3 rounded-md ${
                submitMessage.includes('error')
                ? 'bg-red-900 text-red-100'
                : 'bg-green-900 text-green-100'
              }`}>

                {submitMessage}

              </div>

            )}

          </form>

        </div>

      </div>

    </div>
  );
}